import { IconCheck, IconX } from "@tabler/icons-react";
import { Trans } from "@lingui/macro";

export type PickVerdict = "correct" | "missed" | "falsePositive" | "ignored";

export const PICK_VERDICT_VIEW: Record<PickVerdict, { icon: JSX.Element; label: JSX.Element }> = {
  correct: { icon: <IconCheck size={15} aria-hidden="true" />, label: <Trans>Верно</Trans> },
  missed: { icon: <IconX size={15} aria-hidden="true" />, label: <Trans>Пропуск</Trans> },
  falsePositive: {
    icon: <IconX size={15} aria-hidden="true" />,
    label: <Trans>Ложное срабатывание</Trans>,
  },
  ignored: { icon: <IconCheck size={15} aria-hidden="true" />, label: <Trans>Верно (норма)</Trans> },
};

export function pickVerdictFor(positive: boolean, picked: boolean): PickVerdict {
  if (positive) {
    return picked ? "correct" : "missed";
  }
  return picked ? "falsePositive" : "ignored";
}

export function countPickVerdicts(
  items: readonly { positive: boolean }[],
  selected: ReadonlySet<number>,
): Record<PickVerdict, number> {
  return items.reduce(
    (acc, item, index) => {
      const verdict = pickVerdictFor(item.positive, selected.has(index));
      return { ...acc, [verdict]: acc[verdict] + 1 };
    },
    { correct: 0, missed: 0, falsePositive: 0, ignored: 0 },
  );
}
